import PropTypes from 'prop-types';
import * as MapSearchUtils from './MapSearchUtils.js';
import { SchoolGiveWidget } from '../common/SchoolGiveWidget.js';
import { EquityFocusFlair } from './EquityFocusFlair.js';
import { Svg } from '../common/Svg.js';


function gradeForDisplay(gradeLevel) {
    if (gradeLevel == 0) {
        return 'K'
    } else if (gradeLevel == -1) {
        return 'Pre-K'
    }
    return gradeLevel;
}

const allowSchoolDonation = (schoolData, schoolDonationEnabled) => {
    // Don't advertise school-level-giving for Puerto Rico schools until we have a plan re how to support projects
    // there!
    return schoolDonationEnabled && schoolData.stateCode !== 'PR';
}

export const MapSchoolCard = function({schoolData, schoolDonationEnabled}) {
    const city = schoolData.cityName;
    const state = schoolData.stateCode;
    const lowestGrade = gradeForDisplay(schoolData.lowestGrade);
    const highestGrade = gradeForDisplay(schoolData.highestGrade);
    const enrollment = schoolData.enrollment; // NOTE: not very reliable - this can be 0/null
    const numTeachers = schoolData.numTeachers; // NOTE: not very reliable - this can be 0/null
    const freeReducedPriceLunch = schoolData.freeReducedPriceLunch;
    const schoolInfoPagePath = schoolData.schoolInfoPagePath;
    const equityFocus = schoolData.equityFocus;
    const schoolId = schoolData.schoolId;
    const schoolName = schoolData.schoolName;
    const needLevelForDisplay = MapSearchUtils.Helpers.getNeedLevelForDisplay(freeReducedPriceLunch);
    const totalCostToComplete = Math.round(schoolData.totalCostToComplete);
    const hasRequests = schoolData.totalCostToComplete && schoolData.totalCostToComplete > 0;

    function getGradeLevelHtml() {
        if (lowestGrade && highestGrade) {
            return <li className='chip'>Grades {lowestGrade} - {highestGrade}</li>;
        } else if (lowestGrade && highestGrade && lowestGrade == highestGrade) {
            return <li className='chip'>Grade {lowestGrade} </li>
        }
        return null;
    }

    return (
        <div className='full-width' key={`school_${schoolId}`}>
            <div className={`school-give-section ${hasRequests ? 'no-requests' : ''}`}>
                <ul className='school-chips'>
                    {equityFocus ? <li className='chip'><EquityFocusFlair/></li> : null}
                    <li className='chip'>{city}, {state}</li>
                    {getGradeLevelHtml()}
                    {enrollment > 0 && <li className='chip'>{enrollment} students</li>}
                    {numTeachers > 0 && <li className='chip'>{numTeachers} teachers</li>}
                </ul>
                {allowSchoolDonation(schoolData, schoolDonationEnabled) &&
                    <SchoolGiveWidget
                        schoolId={schoolId}
                        schoolName={schoolName}
                        useAjax={true}
                        totalCostToComplete={totalCostToComplete}
                    />
                }
            </div>
        </div>
    );
};

MapSchoolCard.propTypes = {
    schoolData: PropTypes.object.isRequired,
    totalCostToComplete: PropTypes.number,
    schoolDonationEnabled: PropTypes.bool,
};
